export enum CountryName {
    UnitedStates = 'USA',
    Canada = 'Canada',
}